import * as React from 'react';
import { IDonorBM3ValidatorList } from '@nkr/models/index';
import { BodyScrollEvent, ColDef, ColumnApi, FirstDataRenderedEvent, GridApi, GridReadyEvent, GridSizeChangedEvent, ICellRendererParams, IHeaderParams, RowDataChangedEvent, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { useMemo, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Button, Modal, OverlayTrigger } from 'react-bootstrap';
import { GridWrapper } from './styles';
import Icon from 'react-icons-kit';
import { checkmark } from 'react-icons-kit/icomoon/checkmark';
import SingleEpletMmRisk from '@nkr/views/swap-management/single-eplet-mm-risk';


interface IProps {
    data: IDonorBM3ValidatorList[],
    onGridReady: (e: GridReadyEvent) => void
}

const DonorBM3ValidorGrid: React.FunctionComponent<IProps> = (props) => {

    if (props.data == null) {
        return null;
    }

    const [menuDisplayed, setMenuDisplayed] = useState<boolean>(false);
    const [columns, setColumns] = useState<ColDef[]>([
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    R#
                </SortableHeaderComponent>,
            headerName: 'R#',
            width: 40,
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },
        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'D Alias',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor<br />Alias
                </SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IDonorBM3ValidatorList;
                let { donorAlias, donorId, donorCenterId } = data;

                return (<>
                    {donorId > 0 ? (
                        <a href={'center/' + donorCenterId + '/donor/' + donorId + '/profile'} target="_blank">{donorAlias}</a>
                    ) : (
                        <span>{donorAlias}</span>
                    )}
                </>
                )
            },
            width: 80,
            sortable: true,
            resizable: true
        },
        {
            colId: 'donorType',
            field: 'donorType',
            headerName: 'Donor Type',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor<br />Type
                </SortableHeaderComponent>,
            width: 80,
            sortable: true,
            resizable: true
        },
        {
            colId: 'donorAbo',
            field: 'donorAbo',
            headerName: 'Donor ABO',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor<br />ABO
                </SortableHeaderComponent>,
            width: 35,
            sortable: true,
            resizable: true
        },
        {
            colId: 'donorAge',
            field: 'donorAge',
            headerName: 'Donor Age',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor<br />Age
                </SortableHeaderComponent>,
            width: 35,
            sortable: true,
            resizable: true
        },
        {
            colId: 'donorHeight',
            field: 'donorHeight',
            headerName: 'Donor Height',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor<br />Height
                </SortableHeaderComponent>,
            width: 40,
            sortable: true,
            resizable: true
        },
        {
            colId: 'donorWeight',
            field: 'donorWeight',
            headerName: 'Donor Weight',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Donor<br />Weight
                </SortableHeaderComponent>,
            width: 40,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchRunInclusion',
            field: 'matchRunInclusion',
            headerName: 'Match Run Inclusion',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Match <br />Run <br />Inclusion
                </SortableHeaderComponent>,
            width: 40,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchPreSelectStatus',
            field: 'matchPreSelectStatus',
            headerName: 'Match PreSelect Status',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Match <br />PreSelect <br />Status
                </SortableHeaderComponent>,
            width: 40,
            sortable: true,
            resizable: true
        },
        {
            colId: 'inMatch',
            field: 'inMatch',
            headerName: 'In Match',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    In Match
                </SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IDonorBM3ValidatorList;
                let { inMatch } = data;

                return (<>
                    {inMatch ? <Icon icon={checkmark} size={12} style={{ color: 'green' }} /> : ""}
                </>
                )
            },
            width: 40,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchInSwap',
            field: 'matchInSwap',
            headerName: 'Swap Number',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Swap<br />Number
                </SortableHeaderComponent>,
            width: 40,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchEpletRisk',
            field: 'matchEpletRisk',
            headerName: 'EMM',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    EMM
                </SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IDonorBM3ValidatorList;
                let { singleEpletMmRisk } = data;

                return (
                    <SingleEpletMmRisk data={singleEpletMmRisk} isAdmin={false} centerId={data.recipientCenterId} placement='bottom' />
                )
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.node.rowPinned) {
                    return {
                        frameworkComponent: () => <></>
                    };
                }
            },
            valueGetter: (params: ValueGetterParams) => {
                let data = params.data as IDonorBM3ValidatorList;
                let { singleEpletMmRisk } = data;

                if (singleEpletMmRisk != null)
                    return singleEpletMmRisk.sortValue;
                else
                    return 99999;
            },
            width: 70,
            sortable: true,
            resizable: true
        },

        {
            colId: 'isAvoid',
            field: 'isAvoid',
            headerName: 'Is Avoid',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Is Avoided?
                </SortableHeaderComponent>,
            sortable: true,
            resizable: true,
            valueGetter: (params: ValueGetterParams) => {
                let data = params.data as IDonorBM3ValidatorList;
                return data.isAvoid ? "Yes" : "--";
            },
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IDonorBM3ValidatorList;
                return data.isAvoid ? <span>Yes</span> : "--";
            },
            pinnedRowCellRendererFramework: () => <></>,
        },
        {
            colId: 'matchedPatientAlias',
            field: 'matchedPatientAlias',
            headerName: 'R Alias',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Recipient<br />Alias
                </SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IDonorBM3ValidatorList;
                let { matchedPatientAlias, matchedPatientId, recipientCenterId } = data;

                return (<>
                    {matchedPatientId > 0 ? (
                        <a href={'center/' + recipientCenterId + '/recipient/' + matchedPatientId + '/profile/general'} target="_blank">{matchedPatientAlias}</a>                        
                    ) : (
                        <span>{matchedPatientAlias}</span>
                    )}
                </>
                )
            },
            width: 80,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchedPatientType',
            field: 'matchedPatientType',
            headerName: 'Patient Type',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Patient<br />Type
                </SortableHeaderComponent>,
            width: 60,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchedPatientAbo',
            field: 'matchedPatientAbo',
            headerName: 'Patient ABO',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Patient<br />ABO
                </SortableHeaderComponent>,
            width: 35,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchedPatientAge',
            field: 'matchedPatientAge',
            headerName: 'Patient Age',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Patient<br />Age
                </SortableHeaderComponent>,
            width: 35,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchedPatientHeight',
            field: 'matchedPatientHeight',
            headerName: 'Patient Height',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Patient<br />Height
                </SortableHeaderComponent>,
            width: 35,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchedPatientWeight',
            field: 'matchedPatientWeight',
            headerName: 'Patient Weight',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Patient<br />Weight
                </SortableHeaderComponent>,
            width: 35,
            sortable: true,
            resizable: true
        },
        {
            colId: 'matchedRecipientStatus',
            field: 'matchedRecipientStatus',
            headerName: 'Patient Status',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    Patient<br />Status
                </SortableHeaderComponent>,
            width: 80,
            sortable: true,
            resizable: true
        }
    ]);

    const onGridReady = (e: GridReadyEvent) => {
        props.onGridReady(e);
        e.api.sizeColumnsToFit();
    }

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        e.api.sizeColumnsToFit();
    };


    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
        e.api.sizeColumnsToFit();
    };

    const onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    };


    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);


    return (
        <GridWrapper id='grid-wrapper' className='ag-theme-bootstrap' style={{ marginBottom: 20 }}>
            <AgGridReact
                defaultColDef={{
                    cellClass: 'center-list-cell',
                    headerClass: 'center-list-header',
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                enableCellTextSelection={true}
                enableRangeSelection={true}
                headerHeight={57}
                getRowStyle={function (params) {
                    if (params.node.rowPinned) {
                        return { 'font-weight': 'bold', 'justify-content': 'right', 'background-color': 'lightgray' };
                    }
                }}
                noRowsOverlayComponentFramework={() =>
                    <div>No data...</div>}
                suppressRowHoverHighlight={false}
                suppressCellSelection={true}
                onGridReady={onGridReady}
                onGridSizeChanged={onGridSizeChanged}
                onSortChanged={onSortChanged}
                onRowDataChanged={onRowDataChanged}
                onFirstDataRendered={(props: FirstDataRenderedEvent) => props.api.sizeColumnsToFit()}
            />
        </GridWrapper>
    );
}

export default DonorBM3ValidorGrid;

